import { useState, useCallback, useEffect } from "react";
import { Form, Image, Label } from "semantic-ui-react";
import { useDropzone } from "react-dropzone";
import { useFormik } from "formik";
import { RegisteredDocument, Document } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { initialValues, validationSchema } from "./RegisteredDocumentForm.form";
import { buildStorageUrl, withEmptyOption } from "../../../../utils";
import "./RegisteredDocumentForm.scss";

const registeredDocumentController = new RegisteredDocument();
const documentController = new Document();

export function RegisteredDocumentForm(props) {
  const { studentActive, registeredDocument, onReload, onClose, setLoading } =
    props;
  const { accessToken } = useAuth();

  const [documentOptions, setDocumentOptions] = useState([]);

  const formik = useFormik({
    initialValues: initialValues(registeredDocument),
    validationSchema: validationSchema(registeredDocument),
    validateOnChange: false,
    onSubmit: async (formValue) => {
      try {
        if (registeredDocument) {
          await registeredDocumentController.updateRegisteredDocument(
            accessToken,
            registeredDocument.id,
            formValue,
          );
          onReload();
          onClose();
          return;
        }
        formValue.studentId = studentActive.id;
        await registeredDocumentController.createRegisteredDocument(
          accessToken,
          formValue,
        );
        formik.resetForm();
        onReload();
      } catch (error) {
        console.error(error);
      }
    },
  });

  useEffect(() => {
    (async () => {
      try {
        setDocumentOptions([]);
        const response = await documentController.getDocuments(accessToken);
        const options = response.map((document) => ({
          value: document.id,
          text: document.name,
        }));
        setDocumentOptions(options);
      } catch (error) {
        console.error(error);
      }
    })();
  }, [formik.values.paymentCategoryId, accessToken]);

  const onDrop = useCallback((acceptedFiles) => {
    const file = acceptedFiles[0];
    formik.setFieldValue("path", URL.createObjectURL(file));
    formik.setFieldValue("documentPath", file);
  });

  const { getRootProps, getInputProps } = useDropzone({
    accept: "image/jpeg, image/png",
    onDrop,
  });

  const getDocumentPath = (registeredDocumentData) => {
    if (formik.values.documentPath) {
      return formik.values.path;
    } else if (formik.values.path) {
      return buildStorageUrl(formik.values.path);
    } else if (registeredDocumentData?.path) {
      return buildStorageUrl(registeredDocumentData?.path);
    }
    return "https://placehold.co/300x100?text=Selecciona+o+arrastra+tu+archivo";
  };

  const isImage = (filePath) => {
    const imageExtensions = ["jpg", "jpeg", "png", "gif"];
    const extension = filePath.split(".").pop().toLowerCase();
    return imageExtensions.includes(extension);
  };

  return (
    <Form className="document-form" onSubmit={formik.handleSubmit}>
      <Form.Select
        className="edunova-select"
        name="documentId"
        label="Documento"
        placeholder="Selecciona un documento"
        options={withEmptyOption(documentOptions, "Selecciona un documento")}
        clearable
        onChange={(e, { value }) => formik.setFieldValue("documentId", value)}
        value={formik.values.documentId}
        error={formik.errors.documentId}
      />
      <Form.TextArea
        name="comment"
        label="Comentario"
        onChange={formik.handleChange}
        value={formik.values.comment}
        error={formik.errors.comment}
      />
      <div className="document-form__file" {...getRootProps()}>
        <input {...getInputProps()} />
        {registeredDocument && isImage(formik.values.path) ? (
          <Image src={getDocumentPath(registeredDocument)} />
        ) : registeredDocument &&
          !isImage(formik.values.path) &&
          !formik.values.documentPath &&
          !formik.values.documentPath?.type.includes("image") ? (
          <div className="pdf-file-div">
            {registeredDocument?.path?.split("/").pop()}
          </div>
        ) : formik.values.path &&
          !formik.values.documentPath?.type.includes("image") ? (
          <div className="pdf-file-div">
            {formik.values.documentPath?.name?.split("/").pop()}
          </div>
        ) : (
          <Image src={getDocumentPath(registeredDocument)} />
        )}
      </div>
      {formik.errors.documentPath && (
        <Label prompt className="document-form__label-error" basic pointing>
          {formik.errors.documentPath}
        </Label>
      )}
      <Form.Button
        className="document-form__button"
        primary
        fluid
        loading={formik.isSubmitting}
      >
        Guardar documento
      </Form.Button>
    </Form>
  );
}
